


































import Vue from 'vue'
export default Vue.extend({
  name: 'item-selector-row',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    overwatch: {
      type: Boolean,
    },
    color: {
      type: String,
      required: false,
      default: '',
    },
  },
})
